export default __webpack_public_path__ + "static/BuyCarbonCreditsHero-9d7213845c28add91c24ce883082a673.png";